/* eslint-disable */

export const checkItemRestriction = ({
    customerLevel,
    itemType,
    itemSubType,
    restrictionConfig
}) => {
    const formattedLevel = customerLevel ? `L${customerLevel}` : '';

    if (!restrictionConfig || !restrictionConfig[formattedLevel]) {
        return true;
    }

    const levelConfig = restrictionConfig[formattedLevel];
    const restrictionType = levelConfig?.type;
    const restrictionValues = levelConfig?.value || {};

    const normalizedItemType = (itemType || '')?.trim().toUpperCase();
    const normalizedItemSubType = (itemSubType || '')?.trim().toUpperCase();

    const hasItemType = Object.keys(restrictionValues)?.includes(normalizedItemType);
    
    const subTypeList = hasItemType ? restrictionValues[normalizedItemType] || [] : [];
    
    const matchesSubType = subTypeList?.includes("ALL") || subTypeList?.includes(normalizedItemSubType);

    let result = true;
    if (restrictionType === 1) {
        result = hasItemType && matchesSubType;
        console.log('Restriction type 1 (allowlist):', result ? 'ALLOWED' : 'RESTRICTED');
    } else if (restrictionType === 0) {
        result = !(hasItemType && matchesSubType);
    } else {
        console.log('Invalid restriction type, allowing by default');
    }
    return result;
};

//check and update new restrictions here from GetApproval DE service. 
export const handleItemRestriction = ({
    item,
    customerLevel,
    restrictionConfig,
    EnableCustomerLevelItemRestriction,
    ItemRestrictionCustomerLevels,
}) => {

    if (!item || (!item.itemTypeCode && !item.itemSubTypeCode)) {
        console.log('Item is empty or missing required properties, allowing by default');
        return true;
    }
    
    const itemType = item?.itemTypeCode || '';
    const itemSubType = item?.itemSubTypeCode || '';

    let isAllowed = true
    if(EnableCustomerLevelItemRestriction == '1' && ItemRestrictionCustomerLevels?.customerLevels?.includes(customerLevel)){
        isAllowed = checkItemRestriction({
            customerLevel,
            itemType,
            itemSubType,
            restrictionConfig,
        });
    }
    return isAllowed;
};

export const checkItemRestrictionDeApi = ({
    item,
    restrictionConfig,   // productExclusions object from GetApproval
}: {
    item: any;
    restrictionConfig: any;
}) => {
    const departments = restrictionConfig?.departments;
    if (!departments || departments.length === 0) {
        return true; // no exclusions configured → item is allowed
    }

    const norm = (v?: any) => String(v ?? '').trim().toUpperCase();

    const itemDeptNumber    = norm(item?.departmentNumber);
    const itemSubDeptNumber = norm(item?.subDepartmentNumber);
    const itemBracketNumber = norm(item?.bracketNumber);
    const itemTypeCode      = norm(item?.itemTypeCode);
    const itemSubTypeCode   = norm(item?.itemSubTypeCode);

    // ── Level 1: Department ──────────────────────────────────────────────────
    const matchingDept = departments.find(
        (dept: any) => norm(dept.departmentNumber) === itemDeptNumber
    );
    if (!matchingDept) return true; // dept not in exclusions → allowed

    if (!matchingDept.subDepartments || matchingDept.subDepartments.length === 0) {
        // entire department is blocked
        return false;
    }

    // ── Level 2: SubDepartment ───────────────────────────────────────────────
    const matchingSubDept = matchingDept.subDepartments.find(
        (sub: any) => norm(sub.subDepartmentNumber) === itemSubDeptNumber
    );
    if (!matchingSubDept) return true;

    if (!matchingSubDept.brackets || matchingSubDept.brackets.length === 0) {
        return false;
    }

    // ── Level 3: Bracket ─────────────────────────────────────────────────────
    const matchingBracket = matchingSubDept.brackets.find(
        (bracket: any) => norm(bracket.bracketNumber) === itemBracketNumber
    );
    if (!matchingBracket) return true;

    if (!matchingBracket.itemTypes || matchingBracket.itemTypes.length === 0) {
        return false;
    }

    // ── Level 4: ItemType ────────────────────────────────────────────────────
    const matchingItemType = matchingBracket.itemTypes.find(
        (it: any) => norm(it.itemType) === itemTypeCode
    );
    if (!matchingItemType) return true;

    if (!matchingItemType.itemSubTypes || matchingItemType.itemSubTypes.length === 0) {
        return false;
    }

    // ── Level 5: ItemSubType ─────────────────────────────────────────────────
    const isSubTypeBlocked = matchingItemType.itemSubTypes.some(
        (subType: string) => norm(subType) === itemSubTypeCode
    );
    if (isSubTypeBlocked) {
    }
    return !isSubTypeBlocked;
};

export const handleItemRestrictionDeApi = ({
    item,
    restrictionConfig,
}: {
    item: any;
    restrictionConfig: any;
}) => {
    if (!item || (!item.itemTypeCode && !item.departmentNumber)) {
        console.log('DE API restriction: item is empty or missing key fields, allowing by default');
        return true;
    }

    return checkItemRestrictionDeApi({ item, restrictionConfig });
};
export const resolveItemRestriction = ({
    ItemRestrictionLegacyFlow,
    item,
    EnableCustomerLevelItemRestriction,
    productExclusions,
    customerLevel,
    customerApprovalDetails,
    restrictionConfig,
    ItemRestrictionCustomerLevels,
}: {
    ItemRestrictionLegacyFlow: string | number | undefined;
    item: any;
    EnableCustomerLevelItemRestriction: string | number | undefined;
    productExclusions?: any;
    customerLevel?: string | null;
    customerApprovalDetails?: any;
    restrictionConfig?: any;
    ItemRestrictionCustomerLevels?: any;
}): boolean => {
    if (ItemRestrictionLegacyFlow === '1') {
        // ── New DE Flow ───────────────────────────────────────────────────────
        // Uses productExclusions from the GetApproval DE API.
        return handleItemRestrictionDeApi({
            item,
            restrictionConfig: productExclusions,
        });
    }

    // ── Legacy Flow ───────────────────────────────────────────────────────────
    let specialCaseCustomerLevel: null | string = null;
     if (customerLevel == null && customerApprovalDetails && customerApprovalDetails !== '') {
        specialCaseCustomerLevel = 'LVLNULL';
     } else if (customerApprovalDetails == undefined || customerApprovalDetails == '') {
        specialCaseCustomerLevel = 'NODE';
    }

    return handleItemRestriction({
        item,
        customerLevel: specialCaseCustomerLevel ?? customerLevel,
        restrictionConfig,
        EnableCustomerLevelItemRestriction,
        ItemRestrictionCustomerLevels,
    });
};


